import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Login",
    component: () => import("../views/index/Login.vue"),
  },
  {
    path: "/menu",
    name: "Menu",
    component: () => import("../views/Menu/index.vue"),
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/register/index.vue"),
  },
  {
    path: "/changePsd",
    name: "changePsd",
    component: () => import("../views/register/changePsd.vue"),
  },
  {
    path: "/main",
    name: "Main",
    component: () => import("@/pages/index/index.vue"),
    children: [
      {
        path: "/",
        name: "MainDeafult",
        component: () => import("@/pages/index/index.vue"),
      },

      {
        path: "droneForm",
        name: "DroneForm",
        component: () => import("@/pages/DroneForm/index.vue"),
      },
      {
        path: "flightControl",
        name: "FlightControl",
        component: () => import("@/pages/FlightControl/index.vue"),
      },
      {
        path: "ground",
        name: "GroundStation",
        component: () => import("@/views/ground/index.vue"),
      },
      {
        path: "productionPage",
        name: "ProductionPage",
        component: () => import("@/pages/production/index.vue"),
      },
      {
        path: "@/pages/DroneForm/subItem/taskManage.vue",
        name: "taskManage",
        component: () => import("@/pages/DroneForm/subItem/taskManage.vue"),
      },
      {
        path: "@/pages/DroneForm/subItem/setInfo.vue",
        name: "setInfo",
        component: () => import("@/pages/DroneForm/subItem/setInfo.vue"),
      },
      {
        path: "@/pages/DroneForm/subItem/productionMode.vue",
        name: "productionMode",
        component: () => import("@/pages/DroneForm/subItem/productionMode.vue"),
      },
      //这个是设备管理子页面
      {
        path: "@/pages/DroneForm/subItem/taskDetail.vue",
        name: "taskDetail",
        component: () => import("@/pages/DroneForm/subItem/taskDetail.vue"),
      },
    ],
  },

  {
    path: "/home",
    name: "Index",
    component: () => import("../views/index/index.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
